import React, { Component } from "react";
import BasicCommonFileSettings from "./BasicCommonFileSettings";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
//import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import Checkbox from "@material-ui/core/Checkbox";

const styles = (theme) => ({
  container: {
    margin: "25px 0",
    display: "flex",
    flexDirection: "column",
  },
});
export class BasicOneDriveSettings extends Component {
  state = {
    oneDriveSiteURL: "",
    authOnDomain: false,
  };

  componentDidMount() {
    this.props.updateURL("onedrive.com" + "~");
    this.parseEditKs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      if (this.state.authOnDomain !== prevState.authOnDomain) {
        this.settingsUpdated();
      }
    }

    if (this.props.editKs !== prevProps.editKs) {
      this.parseEditKs();
    }
  }

  parseEditKs = () => {
    if (this.props.editKs && Object.keys(this.props.editKs).length > 0) {
      if (this.props.editKs.url) {
        let urls = this.props.editKs.url.split("~");
        this.setState({ oneDriveSiteURL: urls[1] });
      }
      this.setState({
        authOnDomain: !!this.props.editKs.properties.spiderProperties
          .authOnDomain,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Typography gutterBottom variant="h5">
          <Trans i18nKey="create_ks_onedrive_settings" />
        </Typography>
        <TextField
          style={{ width: "50%" }}
          id="onedrive-site-url"
          label={this.props.t("create_ks_onedrive_site_url")}
          onChange={this.updateOneDriveSiteURL}
          value={this.state.oneDriveSiteURL}
          helperText="e.g. /MyWorkFolder. Leave blank for the root site."
        />
      </div>
    );
  }


  updateOneDriveSiteURL = (e) => {
    let divisionString = "~";
    this.setState({
      oneDriveSiteURL: e.target.value,
    });
    this.props.updateURL("onedrive.com" + divisionString + e.target.value);
  };

  settingsUpdated = () => {
    this.props.setSpiderProperties({
      authOnDomain: this.state.authOnDomain,
    });
  };
}

export default withStyles(styles)(withTranslation()(BasicOneDriveSettings));
